import { observer } from 'mobx-react-lite'
import { Live } from 'models/live'
import { useStores } from 'models/root-store'
import React from 'react'
import { useHistory } from 'react-router'
import { HomePage } from './page'

const HomePageContainer = observer(() => {
  const history = useHistory()
  const {
    livesStore: { lives, status },
  } = useStores()
  return (
    <HomePage
      lives={lives}
      status={status}
      navigateToLiveDetailPage={(id: Live['id']) => history.push(`/live/${id}`)}
    />
  )
})

export default HomePageContainer
